export default __webpack_public_path__ + "static/media/25.25699fed.mp3";